import { READINESS_OPTIONS } from '../../config/assessmentConfig'
import type { RatingValue, ReadinessValue } from './types'

export function readinessToScore(value: ReadinessValue | undefined): number | null {
  if (!value) return null
  const match = READINESS_OPTIONS.find((o) => o.value === value)
  return match ? match.score : null
}

/** Numeric rating or null when not sure / N/A / missing — never coerce to zero silently. */
export function ratingToScore(value: RatingValue | undefined): number | null {
  if (value == null) return null
  if (value === 'not_sure' || value === 'not_applicable') return null
  return value
}

export function averageScores(scores: Array<number | null>): number | null {
  const valid = scores.filter((s): s is number => typeof s === 'number')
  if (!valid.length) return null
  return valid.reduce((a, b) => a + b, 0) / valid.length
}

export function scoreToPercent(avg: number | null): number | null {
  if (avg == null) return null
  return Math.round(Math.max(0, Math.min(1, avg)) * 100)
}

export function confidenceFromScores(
  answered: number,
  applicable: number,
  notSure: number,
): 'high' | 'medium' | 'low' {
  if (applicable === 0) return 'low'
  const coverage = answered / applicable
  if (coverage >= 0.85 && notSure <= 1) return 'high'
  if (coverage >= 0.55) return 'medium'
  return 'low'
}

export function evidenceConfidenceLabel(percent: number | null): string {
  if (percent == null) return 'Self-reported evidence readiness: insufficient responses to score'
  if (percent >= 75) return 'Self-reported evidence readiness: relatively strong process maturity'
  if (percent >= 45) return 'Self-reported evidence readiness: partial process maturity'
  return 'Self-reported evidence readiness: early-stage process maturity'
}
